"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkTabs = exports.getTabLinkIndex = exports.withCurriculumBase = void 0;
var ripl_core_1 = require("@greatmindsorg/ripl-core");
var constants_1 = require("./constants");
var CURRICULUM_PARAM;
(function (CURRICULUM_PARAM) {
    CURRICULUM_PARAM["V1"] = "curriculaCode";
    CURRICULUM_PARAM["V2"] = "curriculum";
})(CURRICULUM_PARAM || (CURRICULUM_PARAM = {}));
var isStudent = function (role) { return role === ripl_core_1.user.Role.Student; };
var withCurriculumBase = function (curriculum) { return function (basePath) {
    return "".concat(basePath, "?").concat(CURRICULUM_PARAM.V1, "=").concat(curriculum);
}; };
exports.withCurriculumBase = withCurriculumBase;
var withCurriculumV2 = function (basePath) {
    /*
     * Reports page is the only app that is already using "curriculum"
     * name as query param, this is a logic for ensuring it has it
     */
    if (!basePath.includes('/reports'))
        return basePath;
    return basePath.replace(CURRICULUM_PARAM.V1, CURRICULUM_PARAM.V2);
};
var getTabLinkIndex = function (pathname, role) {
    return constants_1.PATHS_BY_ROLE[role].map(function (item) { return item.path; }).indexOf(pathname) || 0;
};
exports.getTabLinkIndex = getTabLinkIndex;
var getLinkTabs = function (role, curriculum) {
    var withCurriculum = (0, exports.withCurriculumBase)(curriculum);
    var defaultTabs = constants_1.PATHS_BY_ROLE[role].map(function (item) { return ({
        label: item.label,
        href: withCurriculumV2(withCurriculum(item.path)),
    }); });
    if (!isStudent(role))
        return defaultTabs;
    return constants_1.STUDENT_PATHS.map(function (item) { return ({
        label: item.label,
        href: withCurriculum("".concat(constants_1.STUDENT_BASE_PATH, "/").concat(item.path)),
    }); });
};
exports.getLinkTabs = getLinkTabs;
